// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"31":"otpverification","156":"forget","787":"signup","945":"dashboard","966":"login"}[chunkId] || chunkId) + "." + {"15":"5ac074c3","31":"5b17b3b3","140":"f980b364","156":"64cba00d","268":"0652dbf8","787":"254b1a42","945":"828a8e83","959":"7854e1a3","966":"873f76ae"}[chunkId] + ".js";
};